/* =============================================================================
 * Card — APS primitive (Track D)
 * Surface container matching the design canvas: white surface, hairline border,
 * xl radius, elevation-1. `tone="success"` gives the green-bordered variant used
 * for positive/earned surfaces (unlocked, reveal). `interactive` adds a hover
 * lift (via the `.aps-card-interactive` rule in styles/globals.css).
 * ========================================================================== */
import React from 'react';
import { radius } from '../../styles/tokens';

export type CardTone = 'default' | 'success';

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  tone?: CardTone;
  interactive?: boolean;
  /** Padding in px. Defaults to 20 (the mockup card padding). */
  padding?: number;
}

export const Card = React.forwardRef<HTMLDivElement, CardProps>(
  ({ tone = 'default', interactive, padding = 20, className, style, children, ...rest }, ref) => {
    return (
      <div
        ref={ref}
        className={[interactive ? 'aps-card-interactive' : '', className].filter(Boolean).join(' ') || undefined}
        style={{
          background: 'var(--aps-surface)',
          border: `1px solid ${tone === 'success' ? 'var(--aps-success-border)' : 'var(--aps-border)'}`,
          borderRadius: radius.xl,
          boxShadow: 'var(--aps-elev-1)',
          padding,
          boxSizing: 'border-box',
          transition: interactive
            ? 'transform var(--aps-dur-fast) var(--aps-ease-out), box-shadow var(--aps-dur-fast) var(--aps-ease-out)'
            : undefined,
          ...style,
        }}
        {...rest}
      >
        {children}
      </div>
    );
  }
);

Card.displayName = 'Card';
export default Card;
